export default __webpack_public_path__ + "static/wm_architecture-53dcb3cbf89dc978b43989573305719a.png";